module.exports = __webpack_public_path__ + "media/src/images/man-da4c132a9603e3d012c14350dc4ed223.png";